export default __webpack_public_path__ + "static/media/item-forma-de-pago-gris.0d8c28fd.svg";